<template>
  <div class="bg-white border rounded-lg overflow-hidden text-gray-800 shadow-lg">
    <div>
      <div class="p-4 pl-6 text-sm bg-white border-b">
        <div class="flex items-center">
          <i
            class="far fa-angle-down text-xl hover:text-gray-600 cursor-pointer"
            style="width: 30px;"
          />
          <div class="font-bold">
            Tell us about your clubs and courses
          </div>
        </div>
        <div style="margin-left: 30px">
          <div class="mt-1">
            We need to know a few details to get you started.
          </div>

          <div class="mt-2">
            <PrimaryButton
              text="Start now"
              padding="py-1 px-2"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="p-4 pl-6 text-sm text-brand-500 border-b hover:bg-gray-100 cursor-pointer">
      <div class="flex items-center">
        <i
          class="far fa-angle-right text-xl"
          style="width: 30px;"
        />
        <div class="font-bold">
          Configure your tee sheet
        </div>
      </div>
    </div>

    <div class="p-4 pl-6 text-sm text-brand-500 border-b hover:bg-gray-100 cursor-pointer">
      <div class="flex items-center">
        <i
          class="far fa-angle-right text-xl"
          style="width: 30px;"
        />
        <div class="font-bold">
          Tell us about any events that occur
        </div>
      </div>
    </div>

    <div class="p-4 pl-6 text-sm text-brand-500 border-b hover:bg-gray-100 cursor-pointer">
      <div class="flex items-center">
        <i
          class="far fa-angle-right text-xl"
          style="width: 30px;"
        />
        <div class="font-bold">
          Add additional users to access TeeWiz
        </div>
      </div>
    </div>

    <div class="p-4 pl-6 text-sm text-brand-500 border-b hover:bg-gray-100 cursor-pointer">
      <div class="flex items-center">
        <i
          class="far fa-angle-right text-xl"
          style="width: 30px;"
        />
        <div class="font-bold">
          Create a booking
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import PrimaryButton from '@/app/shared/components/base/button/primaryButton.vue';

export default {

  components: {
    PrimaryButton,
  },

  methods: {
    changeView(view) {
      this.$emit('changeView', view);
    },
  },
};

</script>

<style>
/* width */
::-webkit-scrollbar {
width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
background-color: #999;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
background-color: #555;
}
</style>
